import { Component, computed, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { PercentageValuePipe } from "../../../../core/pipes";

@Component({
  selector: "adaa-progress-number",
  templateUrl: "./progress-number.html",
  styleUrls: ["./progress-number.scss"],
  imports: [TranslatePipe, PercentageValuePipe],
})
export class ProgressNumberComponent {
  value = input<number>(0);
  label = input<string | undefined>(undefined);
  size = input<"sm" | "md" | "lg" | "xl">("lg");
  fillColor = input<string>("#d29f35");
  baseColor = input<string>("#cbd5e1");

  clampedValue = computed(() => Math.min(100, Math.max(0, this.value() ?? 0)));

  sizeClass = computed(() => `size-${this.size()}`);

  gradientStyle = computed(() => {
    return {
      background: `linear-gradient(
        to right,
        ${this.fillColor()} ${this.clampedValue()}%,
        ${this.baseColor()} ${this.clampedValue()}%
      ) text`,
      "-webkit-background-clip": "text",
      "-webkit-text-fill-color": "transparent",
      "background-clip": "text",
    };
  });
}
